import {fetchRead} from './request';
import {sessionTokenCache} from "./session-token";
import { account } from "../appwrite";
const configured=process.env.REACT_APP_COMMERCE_API_URL;
const localHost=host=>['localhost','127.0.0.1','[::1]'].includes(host);
const remoteBrowser=!localHost(window.location.hostname);
// A phone must never call its own localhost for this computer's API.
const BASE=(remoteBrowser && (!configured || localHost(new URL(configured,window.location.origin).hostname))
  ? window.location.origin
  : configured || (process.env.NODE_ENV==='production'?window.location.origin:'http://localhost:8788')).replace(/\/$/,'');
const tokens=sessionTokenCache(account);
export class CommerceError extends Error {
  constructor(message, status, details) {
    super(message);
    this.status = status;
    this.details = details;
  }
}
export async function api(
  path,
  { method = "GET", body, auth = true, signal, deliveryToken } = {},
) {
  const headers = { Accept: "application/json" };
  if (deliveryToken) headers['X-Delivery-Token'] = deliveryToken;
  if (body !== undefined) headers["Content-Type"] = "application/json";
  const generation=tokens.generation;
  if (auth) {
    const jwt=await tokens.get();
    if(generation!==tokens.generation)throw new CommerceError("Your session changed. Please try again.",401);
    headers.Authorization = `Bearer ${jwt}`;
  }
  let response;
  try {
    response = await fetchRead(`${BASE}/v1${path}`, {
      method,
      headers,
      body: body === undefined ? undefined : JSON.stringify(body),
      signal,
    });
  } catch (error) {
    if (error.name === "AbortError") throw error;
    throw new CommerceError("We could not connect. Please try again.", 503);
  }
  if(auth&&generation!==tokens.generation)throw new CommerceError("Your session changed. Please try again.",401);
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 401) {
      tokens.invalidate();
    }
    throw new CommerceError(
      data.error || "Something went wrong. Please try again.",
      response.status,
      data.details,
    );
  }
  return data;
}
export const publicApi = (path, options = {}) =>
  api(path, { ...options, auth: false });
export function queryString(values) {
  const params = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "")
      params.set(key, value);
  });
  return params.toString();
}
export const clearApiSession = () => {
  tokens.invalidate();
};
